/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { Anexos } from '../customInput/anexos';
import CustomInput, { SelectInput } from '../customInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import {
  CreateFolder,
  GetDocumentos,
  GetDowloadFile,
  GetFileHistory,
  GetFolders,
  SendDocumentRequest,
  SendMultipleDocumentRequest,
  UploadDocumento,
} from './auth';
import { isValid } from 'src/services/auth';

import { ReactComponent as Reload } from 'src/assets/icons/reload.svg';
import { ReactComponent as Add } from 'src/assets/icons/oldPortal/adicionar.svg';
import { ReactComponent as Grid } from 'src/assets/icons/grid.svg';
import { ReactComponent as List } from 'src/assets/icons/dashboard/list.svg';
import { ReactComponent as DowloadIcon } from 'src/assets/icons/download.svg';
import { ReactComponent as Send } from 'src/assets/icons/sendPaperPlane.svg';
import { ReactComponent as HistoryIcon } from 'src/assets/icons/hist.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as AddFolder } from 'src/assets/icons/addFolder.svg';
import { ReactComponent as FileIcon } from 'src/assets/icons/extension/file.svg';

import { LoadGif } from '../LoadGif';
import { CheckBox } from '@mui/icons-material';
import showToast from '../toastyService';
import { sliderClasses } from '@mui/material';

export default function Assinatura() {
  const [load, setLoad] = useState(false);
  const [plugToken, setPlugToken] = useState('');
  const [hasToken, setHasToken] = useState(false);

  const [modo, setModo] = useState('lista');
  const [folderList, setFolderList] = useState([]);
  const [folder, setFolder] = useState('');
  const [docList, setDocList] = useState([]);

  const [fileToUpload, setFileToUpload] = useState();
  const [nameToUpload, setNameToUpload] = useState();

  const [input, setInput] = useState('');
  const [docToSend, setDocToSend] = useState();
  const [folderToSend, setFolderToSend] = useState('');
  const [sendList, setSendList] = useState([]);
  const [sendInfo, setSendInfo] = useState({ subject: '', message: '' });

  const [fileHistory, setFileHistory] = useState([]);

  const [popup, setPopup] = useState('');
  const [popupFolder, setPopupFolder] = useState(false);

  const [folderToCreate, setFolderToCreate] = useState('');

  const [filtro, setFiltro] = useState('');
  const [filtro2, setFiltro2] = useState('');

  const [selectedFiles, setSelectedFiles] = useState([]);

  function timedLoad(time) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, time);
  }

  useEffect(() => {
    setPlugToken(localStorage.getItem('plugtoken'));
  }, []);

  useEffect(() => {
    GetInfo();
    setHasToken(isValid(plugToken));
  }, [plugToken]);

  function GetInfo() {
    setLoad(true);

    GetFolders()
      .then((res) => {
        setFolderList(res);
        //console.log(res);
      })
      .catch((err) => {
        console.error(err);
        showToast('error', 'Erro');
      });

    GetDocumentos()
      .then((res) => {
        setDocList(res);
        //console.log(res);
      })
      .catch((err) => {
        console.error(err);
        showToast('error', 'Erro');
      })
      .finally(timedLoad(1000));
  }

  function DownloadFile(key, name, extension) {
    setLoad(true);
    GetDowloadFile(key)
      .then((blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blob], { type: 'application/pdf' })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name}.${extension}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((err) => {
        console.error(err);
        showToast('error', 'Erro');
      })
      .finally(timedLoad(3000));
  }

  function ViewHistory(key) {
    setLoad(true);

    setFileHistory([]);
    GetFileHistory(key)
      .then((res) => {
        setFileHistory(res);
        showToast('success', 'Sucesso');
        //console.log(res);
      })
      .catch((err) => {
        console.error(err);
        showToast('error', 'Erro');
      })
      .finally(timedLoad(1000));
  }

  function AddFile(file, name, folder) {
    UploadDocumento(false, file, name, folder)
      .then((res) => {
        //console.log(res);
        showToast('success', 'Sucesso');
        setPopup('');
      })
      .catch((err) => {
        console.error(err);
        showToast('error', 'Erro');
      });
  }

  function handleKey(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (input.trim() !== '') {
        setSendList((prev) => [...prev, input.trim()]);
        setInput('');
      }
    }
  }
  function removeFromSendList(indexToRemove) {
    setSendList((prev) => prev.filter((_, i) => i !== indexToRemove));
  }

  function SolicitarAssinatura(key, seubject, message) {
    setLoad(true);

    const recipients = sendList.map((user) => ({
      send_to: user,
      message: message,
      doubleauth: false,
      allow_selfie: false,
      allow_document: false,
      allow_document_back: false,
      signature_type: 'Cliente',
      reminder: user,
      send_finished: true,
      signature_mode: 'all', // pode ser 'draw', 'text', 'upload' se quiser
      fields: [
        {
          page: 1,
          type: 'signature',
          xPos: -999, // assinatura em página extra
          yPos: -999,
          width: 200,
          height: 75,
        },
      ],
    }));

    if (isValid(key) && recipients.length > 0)
      SendDocumentRequest({
        justLog: false,
        documentKey: key,
        subject: seubject || 'Assinatura de documento',
        recipients: recipients,
      })
        .then((res) => {
          //console.log(res);
          showToast('success', 'Sucesso');
          setPopup('');
        })
        .catch((err) => {
          console.error(err);
          showToast('error', 'Erro');
        })
        .finally(timedLoad(3000));
  }

  async function SolicitarAssinaturaVarios(subject, message) {
    setLoad(true);

    for (const file of selectedFiles) {
      const recipients = sendList.map((user) => ({
        send_to: user,
        message: message,
        doubleauth: false,
        allow_selfie: false,
        allow_document: false,
        allow_document_back: false,
        signature_type: 'Cliente',
        reminder: user,
        send_finished: true,
        signature_mode: 'all',
        fields: [
          {
            page: 1,
            type: 'signature',
            xPos: -999,
            yPos: -999,
            width: 200,
            height: 75,
          },
        ],
      }));

      if (!isValid(file) || recipients.length === 0) continue;

      try {
        await SolicitarAssinatura({
          justLog: false,
          documentKey: file,
          subject: subject || 'Assinatura de documento',
          recipients: recipients,
        });
        showToast('success', 'Sucesso');
      } catch (err) {
        console.error(err);
        showToast('error', err.message || 'Erro');
        break;
      }
    }

    setPopup('');
    timedLoad(1000);
  }

  function NovaPasta(name) {
    setLoad(true);
    CreateFolder(false, name)
      .then((res) => {
        showToast('success', 'Sucesso');
        GetInfo();
      })
      .catch((err) => {
        console.error(err);
        showToast('error', 'Erro');
      })
      .finally(timedLoad(1000));
  }

  return (
    <div className="Assinatura">
      {load && <LoadGif />}
      {load && <button onClick={() => setPopup('')} className="block load" />}

      {popup !== '' && (
        <button onClick={() => setPopup('')} className="block" />
      )}
      {popup === 'AddDoc' && (
        <div className="ppup absoluteCenter mainShadow">
          <div className="addContent">
            <h3>Enviar Novo Documento</h3>

            <input
              type="file"
              accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
              onChange={(e) => setFileToUpload(e.target.files[0])}
            />

            <CustomInput
              Type="text"
              PlaceHolder="Nome do Arquivo"
              OnChange={(e) => setNameToUpload(e.target.value)}
            />

            <h5>Apenas PDF, Word, Excel e Power Point permitidos.</h5>

            <select onChange={(e) => setFolderToSend(e.target.value)}>
              <option key={0} value={''}>
                Pasta Padrão
              </option>
              {folderList.map((item, index) => (
                <option key={index + 1} value={item.id}>
                  {item.folder}
                </option>
              ))}
            </select>
            <button
              onClick={() => setPopupFolder(true)}
              className="mainButton yellow"
            >
              <AddFolder /> Criar nova pasta
            </button>

            <div className="row">
              <button className="mainButton gray" onClick={() => setPopup('')}>
                <End /> Cancelar
              </button>
              <button
                className="mainButton turquoise"
                onClick={() =>
                  AddFile(fileToUpload, nameToUpload, folderToSend)
                }
                disabled={!isValid(nameToUpload) || !isValid(fileToUpload)}
              >
                <Check />
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}
      {popupFolder && (
        <div className="ppup absoluteCenter mainShadow">
          <CustomInput
            Type="text"
            PlaceHolder="Criar Nova Pasta"
            OnChange={(e) => setFolderToCreate(e.target.value)}
          />
          <div className="row">
            <button
              className="mainButton gray"
              onClick={() => setPopupFolder(false)}
            >
              <End /> Cancelar
            </button>
            <button
              className="mainButton turquoise"
              onClick={() => NovaPasta(folderToCreate)}
              disabled={!isValid(folderToCreate)}
            >
              <Check />
              Criar
            </button>
          </div>
        </div>
      )}
      {popup === 'solicitar' && (
        <div className="ppup absoluteCenter mainShadow">
          <div className="solicitarContent">
            <h3>Solicitação de Assinatura</h3>

            <h5>Digite o(s) e-mail(s) e/ou celular(es)</h5>
            <h6>
              Para telefones do Brasil utilize os seguintes formatos:
              11988772233 ou (11)98877-2233 Para números internacionais utilize
              o + antes do número, seguindo pelo DDI e pelo número sem pontos e
              traços.
            </h6>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKey}
              placeholder="Digite e pressione espaço ou enter"
            />
            <div className="sendList">
              {sendList.map((item, index) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const phoneRegex = /^(\(?\d{2}\)?\s?)?\d{4,5}-?\d{4}$/;

                const isValid = emailRegex.test(item) || phoneRegex.test(item);

                return (
                  <div key={index} className={`item ${isValid ? '' : 'erro'}`}>
                    {item}
                    <button onClick={() => removeFromSendList(index)}>x</button>
                  </div>
                );
              })}
            </div>

            <CustomInput
              Type="text"
              PlaceHolder="Assunto do E-Mail"
              OnChange={(e) =>
                setSendInfo((prev) => ({ ...prev, subject: e.target.value }))
              }
            />

            <h5> Mensagem ao(s) destinatário(s)</h5>
            <textarea
              onChange={(e) =>
                setSendInfo((prev) => ({ ...prev, message: e.target.value }))
              }
            />

            <div className="row">
              <button className="mainButton gray" onClick={() => setPopup('')}>
                <End /> Cancelar
              </button>
              <button
                className="mainButton turquoise"
                onClick={() => {
                  SolicitarAssinatura(
                    docToSend,
                    sendInfo.subject,
                    sendInfo.message
                  );
                }}
                disabled={sendList.length < 1}
              >
                <Check />
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}
      {popup === 'solicitarVarios' && (
        <div className="ppup absoluteCenter mainShadow">
          <div className="solicitarContent varios">
            <div>
              <h3>Solicitação de Assinatura de Vários Documentos</h3>

              <h5>Digite o(s) e-mail(s) e/ou celular(es)</h5>
              <h6>
                Para telefones do Brasil utilize os seguintes formatos:
                11988772233 ou (11)98877-2233 Para números internacionais
                utilize o + antes do número, seguindo pelo DDI e pelo número sem
                pontos e traços.
              </h6>
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKey}
                placeholder="Digite e pressione espaço ou enter"
              />
              <div className="sendList">
                {sendList.map((item, index) => {
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  const phoneRegex = /^(\(?\d{2}\)?\s?)?\d{4,5}-?\d{4}$/;

                  const isValid =
                    emailRegex.test(item) || phoneRegex.test(item);

                  return (
                    <div
                      key={index}
                      className={`item ${isValid ? '' : 'erro'}`}
                    >
                      {item}
                      <button onClick={() => removeFromSendList(index)}>
                        x
                      </button>
                    </div>
                  );
                })}
              </div>

              <CustomInput
                Type="text"
                PlaceHolder="Assunto do E-Mail"
                OnChange={(e) =>
                  setSendInfo((prev) => ({ ...prev, subject: e.target.value }))
                }
              />

              <h5> Mensagem ao(s) destinatário(s)</h5>
              <textarea
                onChange={(e) =>
                  setSendInfo((prev) => ({ ...prev, message: e.target.value }))
                }
              />

              <div className="row">
                <button
                  className="mainButton gray"
                  onClick={() => setPopup('')}
                >
                  <End /> Cancelar
                </button>
                <button
                  className="mainButton turquoise"
                  onClick={() => {
                    SolicitarAssinaturaVarios(
                      sendInfo.subject,
                      sendInfo.message
                    );
                  }}
                  disabled={sendList.length < 1}
                >
                  <Check />
                  Enviar
                </button>
              </div>
            </div>
            <div>
              <h3>Documentos Selecionados</h3>
              <div className="lista">
                {docList
                  .filter((item) => selectedFiles.includes(item.document_key))
                  .map((item) => (
                    <span key={item.document_key}>
                      <FileIcon /> {item.name}
                    </span>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {popup === 'historico' && !load && (
        <div className="ppup absoluteCenter mainShadow historyPpup">
          <div className="historyContent">
            <h3>Histórico</h3>
            <div className="list">
              {fileHistory.map((item, index) => {
                const findUppercase = item.activity.split(
                  /(\b[A-ZÇÃÉÍÓÚ]{2,}(?:\s+[A-ZÇÃÉÍÓÚ]{2,})*\b)/g
                );
                return (
                  <div key={index} className="item">
                    <span> {item.time} </span>
                    <span>
                      <div className="bullet" />
                      <div className="line" />
                    </span>
                    <span>
                      {findUppercase.map((p, i) =>
                        p === p.toUpperCase() && /[A-Z]/.test(p) ? (
                          <b key={i}>{p}</b>
                        ) : (
                          p
                        )
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
            <div className="row">
              <button className="mainButton gray" onClick={() => setPopup('')}>
                <End /> Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {!hasToken && (
        <div className="popup mainShadow absoluteCenter warn">
          <FontAwesomeIcon icon={faExclamationTriangle} /> Acesso não
          configurado
        </div>
      )}

      {hasToken && (
        <div className="Content">
          <div className="HotBar">
            <button
              className="mainButton turquoise"
              onClick={() => {
                setPopup('AddDoc');
                setFileToUpload('');
                setNameToUpload('');
                setFolderToSend('');
              }}
            >
              <Add />
              Enviar Novo Documento
            </button>

            <button
              onClick={() => GetInfo()}
              className={`mainButton turquoise reload`}
            >
              <Reload />
            </button>

            <select onChange={(e) => setFolder(e.target.value)}>
              <option key={0} value={''}>
                Selecionar Pasta
              </option>
              {folderList.map((item, index) => (
                <option key={index + 1} value={item.folder}>
                  {item.folder}
                </option>
              ))}
            </select>

            <button
              className="mainButton turquoise solicitarVarios"
              disabled={selectedFiles.length < 1}
              onClick={() => {
                setPopup('solicitarVarios');
              }}
            >
              <Send />
              Solicitar Assinatura de Vários Documentos
            </button>

            <button
              className="mainButton turquoise icon"
              onClick={() => setModo('lista')}
              disabled={modo === 'lista'}
            >
              <List />
            </button>
            <button
              className="mainButton turquoise icon"
              onClick={() => setModo('grade')}
              disabled={modo === 'grade'}
            >
              <Grid />
            </button>
          </div>
          <div className={`Table ${modo}`}>
            <div className="filter mainShadow">
              <h6> Filtros </h6>

              <div>
                <label>
                  <input
                    type="radio"
                    name="filtro"
                    value=""
                    checked={filtro === ''}
                    onChange={(e) => setFiltro(e.target.value)}
                  />
                  Tudo
                </label>
                <label>
                  <input
                    type="radio"
                    name="filtro"
                    value="finalizado"
                    checked={filtro === 'finalizado'}
                    onChange={(e) => setFiltro(e.target.value)}
                  />
                  Finalizado
                </label>
                <label>
                  <input
                    type="radio"
                    name="filtro"
                    value="assinado"
                    checked={filtro === 'assinado'}
                    onChange={(e) => setFiltro(e.target.value)}
                  />
                  Assinado
                </label>
                <label>
                  <input
                    type="radio"
                    name="filtro"
                    value="Unsigned"
                    checked={filtro === 'Unsigned'}
                    onChange={(e) => setFiltro(e.target.value)}
                  />
                  Pendente
                </label>
              </div>

              <hr />

              <div>
                <label>
                  <input
                    type="radio"
                    name="filtro2"
                    value=""
                    checked={filtro2 === ''}
                    onChange={(e) => setFiltro2(e.target.value)}
                  />
                  Tudo
                </label>
                <label>
                  <input
                    type="radio"
                    name="filtro2"
                    value="pdf"
                    checked={filtro2 === 'pdf'}
                    onChange={(e) => setFiltro2(e.target.value)}
                  />
                  PDF
                </label>

                <label>
                  <input
                    type="radio"
                    name="filtro2"
                    value="docx"
                    checked={filtro2 === 'docx'}
                    onChange={(e) => setFiltro2(e.target.value)}
                  />
                  Word
                </label>

                <label>
                  <input
                    type="radio"
                    name="filtro2"
                    value="xlsx"
                    checked={filtro2 === 'xlsx'}
                    onChange={(e) => setFiltro2(e.target.value)}
                  />
                  Excel
                </label>

                <label>
                  <input
                    type="radio"
                    name="filtro2"
                    value="pptx"
                    checked={filtro2 === 'pptx'}
                    onChange={(e) => setFiltro2(e.target.value)}
                  />
                  Power Point
                </label>
              </div>
            </div>

            {docList
              .filter(
                (item) =>
                  (folder === '' || folder === item.folder) &&
                  (filtro === '' || item.status === filtro) &&
                  (filtro2 === '' || item.extension === filtro2)
              )
              .map((item, index) => (
                <div key={index} className={`TableItem ${modo}`}>
                  <button
                    className={`itemSelect ${selectedFiles.includes(item.document_key) ? 'active' : ''} `}
                    onClick={() => {
                      if (selectedFiles.includes(item.document_key)) {
                        setSelectedFiles(
                          selectedFiles.filter(
                            (key) => key !== item.document_key
                          )
                        );
                      } else {
                        setSelectedFiles([...selectedFiles, item.document_key]);
                      }
                    }}
                  >
                    {selectedFiles.includes(item.document_key) && <Check />}
                  </button>

                  <span className={`status ${item.status.replace(/\s+/g, '')}`}>
                    • {item.status}
                  </span>
                  <p>
                    {item.name}
                    <span className="extension"> .{item.extension} </span>
                  </p>

                  <div className="controls">
                    <button
                      className="mainButton turquoise"
                      onClick={() => {
                        setPopup('solicitar');
                        setSendList([]);
                        setSendInfo({ subject: '', message: '' });
                        setDocToSend(item.document_key);
                      }}
                    >
                      <Send />
                      {modo === 'lista' && 'Solicitar Assinatura'}
                    </button>

                    <button
                      className="dowload mainButton gray"
                      onClick={() =>
                        DownloadFile(
                          item.document_key,
                          item.name,
                          item.extension
                        )
                      }
                    >
                      <DowloadIcon />
                      {modo === 'lista' && 'Download'}
                    </button>

                    <button
                      className="dowload mainButton yellow"
                      onClick={() => {
                        setPopup('historico');
                        ViewHistory(item.document_key);
                      }}
                    >
                      <HistoryIcon />
                      {modo === 'lista' && 'Historico'}
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
